import React from "react";
import { PayGoFormData, PayGoFormErrorsState } from "../PayGoFormPresenter";
import { UserRole } from "../../../../../user/types/user.types";
import styles from "./PayGoForm.module.scss";
import MessageCard from "../../../../../../common/components/molecule/MessageCard/MessageCard";
import TextInput from "../../../../../../common/components/atom/TextInput/TextInput";
import Button from "../../../../../../common/components/atom/Button/Button";

export interface PaygoFormViewProps {
  setFormData: (key: keyof PayGoFormData, value: any) => void;
  formData: PayGoFormData;
  userPickerRender?: () => JSX.Element;
  stationPickerRender?: () => JSX.Element;
  errorStatus?: PayGoFormErrorsState;
  handleSubmit?: () => void;
  messageError?: string | null;
  isLoading?: boolean;
  submitLabel?: string;
  description?: string;
  title?: string;
  maxWidth?: string;
  currentUserRoleCreator?: UserRole;
  connectorPicker ?: () => JSX.Element;
}

export default function PaygoFormView({
  handleSubmit,
  messageError,
  errorStatus,
  isLoading,
  submitLabel = "Créer",
  description = "Saisissez les informations du paygo",
  maxWidth = "700px",
  title,
  formData,
  setFormData,
  currentUserRoleCreator,
  userPickerRender,
  stationPickerRender,
  connectorPicker
}: PaygoFormViewProps) {
  return (
    <div style={{ maxWidth: maxWidth }}>
      <div className={[styles["container"]].join(" ")}>
        {title && (
          <h1 className={[styles["container__title"]].join(" ")}>{title}</h1>
        )}
        <p className={[styles["container__description"]].join(" ")}>
          {description}
        </p>
        <div className={[styles["container__error-message"]].join(" ")}>
          <MessageCard variant="danger" message={messageError} width100 />
        </div>
        <form
          className={[styles["form"]].join(" ")}
          onSubmit={(e) => {
            e.preventDefault();
            handleSubmit && handleSubmit();
          }}
        >
          <div className={[styles["form__item"]].join(" ")}>
            <TextInput
              label={"kWh"}
              value={formData?.amountKwh}
              error={errorStatus?.isErrorAmountKwh}
              onChange={(e) => {
                const value = e.target.value;
                setFormData("amountKwh", value);
              }}
              type="number"
            />
          </div>

          {userPickerRender && (
            <div className={[styles["form__item"]].join(" ")}>
              {userPickerRender()}
            </div>
          )}

          {stationPickerRender && (
            <div className={[styles["form__item"]].join(" ")}>
              {stationPickerRender()}
            </div>
          )}

          {connectorPicker && (
            <div className={[styles["form__item"]].join(" ")}>
              {connectorPicker()}
            </div>
          )}

          <div className={[styles["form__item"]].join(" ")}>
            <TextInput
              label={"Information complémentaire"}
              value={formData?.description}
              error={errorStatus?.isErrorDescription}
              multiline
              rows={5}
              onChange={(e) => {
                const value = e.target.value;
                setFormData("description", value);
              }}
            />
          </div>

          <div className={[styles["form__button-container"]].join(" ")}>
            <div className={[styles["form__button-container__item"]].join(" ")}>
              <Button
                isLoading={isLoading}
                onClick={handleSubmit}
                type={"submit"}
              >
                {submitLabel}
              </Button>
            </div>
          </div>
        </form>
      </div>
    </div>
  );
}
